// extracted by mini-css-extract-plugin
module.exports = {"pressReleaseSnippet":"PressReleaseSnippet_pressReleaseSnippet__AvPKv"};